export class DefaultIcon {
  static About = 'pi info'; //save as info
  static Account = 'pi account_circle';
  static Add = 'pi add_circle';
  static AddMultiple = 'pi playlist_add';
  static Admin = 'pi admin_panel_settings';
  static Alias = 'pi device_unknown';
  static Approve = 'pi thumb_up_alt';
  static ApprovalPending = 'pi thumb_up_off_alt';
  static Assets = 'pi router';
  static Attach = 'pi attach_file';
  static Automation = 'pi auto_mode';
  static Billing = 'pi receipt_long';
  static Blocked = 'pi cancel'; //blocked has a weird right margin
  static Bonus = 'pi emoji_events';
  static BlurOn = 'pi blur_on';
  static BlurOff = 'pi blur_off';
  static Build = 'pi build';
  static Builder = 'pi edit_calendar';
  static Calendar = 'pi work_history';
  static Car = 'pi car_rental';
  static Check = 'pi check';
  static CheckBox = 'pi check_box';
  static Cancel = 'pi cancel';
  static CancelTime = 'pi hourglass_disabled';
  static Calculate = 'pi calculate';
  static Change = 'pi change_circle';
  static Clear = 'pi clear';
  static Close = 'pi close';
  static Columns = 'pi view_column';
  static CollapseAll = 'pi exposure';
  static Collapse = 'pi compress';
  static Comment = 'pi comment';
  static Company = 'pi apartment';
  static Copy = 'pi content_copy';
  static Dashboard = 'pi dashboard';
  static DeathInFamily = 'pi museum';
  static Delay = 'pi running_with_errors';
  static Delete = 'pi delete';
  static DeleteForever = 'pi delete_forever';
  static Directions = 'pi directions';
  static Dispatch = 'pi departure_board';
  static Dispute = 'pi quiz';
  static Division = 'pi supervised_user_circle';
  static Download = 'pi download';
  static DropDown = 'pi arrow_drop_down';
  static Edit = 'pi edit';
  static Employee = 'pi people'; //dup of Team but separate for now
  static Email = 'pi email';
  static End = 'pi keyboard_tab';
  static Error = 'pi error';
  static EventDate = 'pi event';
  static Expand = 'pi expand';
  static ExpandAll = 'pi iso';
  static Expense = 'pi receipt';
  static ExternalUsers = 'pi connect_without_contact';
  static FilterList = 'pi filter_list';
  static FlatRate = 'pi vertical_align_top';
  static Fuel = 'pi local_gas_station';
  static Gauge = 'pi speed';
  static GPS = 'pi satellite_alt';
  static GPSOff = 'pi gps_off';
  static GroupMenu = 'pi list';
  static GroupRemove = 'pi group_remove';
  static Hide = 'pi visibility_off';
  static History = 'pi history';
  static Holiday = 'pi house';
  static HOS = 'pi access_time';
  static Hub = 'pi place';
  static Info = 'pi info'; //same as about
  static Inbox = 'pi inbox';
  static Incentives = 'pi payments';
  static Integrity = 'pi fact_check';
  static ItemMenu = 'pi more_vert';
  static Journal = 'pi menu_book';
  static Launch = 'pi launch';
  static License = 'pi id_card';
  static LineHaul = 'pi add_road'; //need better icon
  static Link = 'pi link';
  static Location = 'pi map';
  static LocationSearch = 'pi location_searching';
  static Lock = 'pi lock';
  static Login = 'pi login';
  static Logout = 'pi logout';
  static Logs = 'pi assignment';
  static Maintenance = 'pi car_repair';
  static ManagerReport = 'pi outlined_flag';
  static AutoTransmission = 'pi auto_transmission';
  static Map = 'pi map';
  static Medical = 'pi stethoscope';
  static Menu = 'pi menu'; //menu //new
  static Merge = 'pi merge';
  static Messaging = 'pi outgoing_mail';
  static MiscWork = 'pi transfer_within_a_station';
  static Miles = 'pi edit_road';
  static Military = 'pi military_tech';
  static Missing = 'pi not_listed_location';
  static Money = 'pi attach_money'; //dup of Wage but separate for now
  static More = 'pi more';
  static Move = 'pi drive_file_move';
  static Next = 'pi skip_next';
  static FastForward = 'pi fast_forward';
  static None = '';
  static Odometer = 'pi odometer';
  static Operations = 'pi operations';
  static Organization = 'pi account_tree';
  static Outbox = 'pi outbox';
  static Parking = 'pi local_parking';
  static Password = 'pi password';
  static Payroll = 'pi local_atm';
  static Pending = 'pi snooze';
  static Person = 'pi person';
  static Personal = 'pi person_off';
  static PerDiem = 'pi hotel';
  static PersonRemove = 'pi person_remove';
  static ProfDevelopment = 'pi school';
  static Print = 'pi print';
  static Previous = 'pi skip_previous';
  static Phone = 'pi phone';
  static Publish = 'pi publish';
  static Reconcile = 'pi compare_arrows';
  static Refresh = 'pi refresh';
  static Retention = 'pi loyalty';
  static Regulator = 'pi done_all';
  static Reject = 'pi thumb_down_alt';
  static RejectPending = 'pi thumb_down_off_alt';
  static Remove = 'pi remove';
  static Report = 'pi insert_chart_outlined';
  static Review = 'pi thumbs_up_down';
  static Rewind = 'pi fast_rewind';
  static Route = 'pi timeline';
  static Rules = 'pi format_list_numbered';
  static Run = 'pi bus_alert';
  static ScheduleRequest = 'pi free_cancellation';
  static Search = 'pi search';
  static SelectAll = 'pi check_box';
  static Settings = 'pi settings';
  static Settlements = 'pi library_books';
  static Schedule = 'pi date_range';
  static SignUp = 'pi app_registration';
  static Show = 'pi visibility'; //eye same as View
  static Sick = 'pi sick';
  static Spot = 'pi maps_home_work';
  static Start = 'pi start';
  static Subscription = 'pi schedule_send';
  static Sync = 'pi sync_alt';
  static TableMenu = 'pi summarize';
  static Team = 'pi people';
  static Today = 'pi today';
  static Time = 'pi access_time';
  static TimeClock = 'pi punch_clock';
  static TimeOff = 'pi event_busy';
  static Transpose = 'pi pivot_table_chart';
  static TrendingUp = 'pi trending_up';
  static TrendingDown = 'pi trending_down';
  static Truck = 'pi local_shipping';
  static Unclaimed = 'pi psychology_alt';
  static UnCheckBox = 'pi check_box_outline_blank';
  static UnDelete = 'pi restore_from_trash';
  static Unexcused = 'pi sentiment_dissatisfied';
  static Unlink = 'pi link_off';
  static Unlock = 'pi lock_open';
  static Unpaid = 'pi unpaid';
  static UnselectAll = 'pi check_box_outline_blank';
  static Update = 'pi update';
  static Vacation = 'pi beach_access';
  static Validate = 'pi verified';
  static View = 'pi visibility'; //eye same as Show
  static ViewList = 'pi manage_search';
  static Wage = 'pi attach_money'; //dup of Money but separate for now
  static Warning = 'pi warning';
  static ShiftDay = 'pi brightness_high';
  static ShiftNight = 'pi mode_night';
  static ShiftAll = 'pi brightness_medium';
}
